/**
 * The number of decimal places that user can withdraw.
 * Actual on-chain representation scale can be higher (e.g. 16).
 */
export const WITHDRAW_AMOUNT_SCALE = 8;
